import { Component, type ReactNode } from "react";
import { BridgelayerMark } from "@/components/brand/Logo";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error: unknown): State {
    const message =
      error instanceof Error ? error.message : "An unexpected error occurred.";
    return { hasError: true, message };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-6 text-center gap-4">
          <BridgelayerMark size={40} className="text-muted-foreground opacity-50" />
          <div className="space-y-1">
            <h1 className="text-lg font-semibold text-foreground">
              Something went wrong
            </h1>
            <p className="text-sm text-muted-foreground max-w-sm">
              {this.state.message}
            </p>
          </div>
          <button
            onClick={this.handleReload}
            className="text-sm font-medium text-[hsl(var(--primary))] underline-offset-4 hover:underline"
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
